var _linearGradient;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640.138,
    height: 640.138,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d56d",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    offset: 1
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#logo_svg__a",
    id: "logo_svg__b",
    x1: 236.141,
    y1: 287.164,
    x2: 760.822,
    y2: 287.164,
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-141.002 31.682)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "logo_svg__logo-bg",
    style: {
      display: "inline",
      fill: "#94b0da",
      fillOpacity: 1,
      strokeWidth: 1.42622
    },
    cx: 462.782,
    cy: 286.87,
    r: 306.317
  }), /*#__PURE__*/React.createElement("g", {
    className: "logo_svg__logo-ladle"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#d17832",
      fillOpacity: 1
    },
    d: "M468.088 544.643c-6.974-8.499-19.985-14.122-43.337-14.216-25.792-.104-36.204 4.63-40.265 13.39l-513.368-49.226c-3.472-16.977-9.929-32.127-18.77-43.298-9.681-12.23-21.376-15.248-33.745-18.86l-95.359-5.598c-35.532-2.086-55.431 40.861-55.431 91.265 0 50.405 24.87 89.47 55.432 91.265l95.357 5.6c24.524-.001 45.313-26.233 52.62-62.575l510.797 48.98c.708 14.384 6.82 21.589 39.336 22.752 46.804 1.673 51.138-20.729 53.444-43.356 1.342-13.163 1.193-26.49-6.711-36.123z",
    transform: "rotate(-51.85)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      fill: "#5f1004",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#5f1004",
      fillOpacity: 1
    },
    d: "M179.23 465.804a91.265 55.432 38.15 0 0-2.853 2.924 91.265 55.432 38.15 0 0 37.53 99.966A91.265 55.432 38.15 0 0 319.92 581.48a91.265 55.432 38.15 0 0 4.122-6.761 91.265 55.432 38.15 0 1-103.24-15.623 91.265 55.432 38.15 0 1-41.571-93.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#5f1004",
      fillOpacity: 1
    },
    d: "M205.58 435.547a91.265 55.432 38.15 0 0-2.854 2.924 91.265 55.432 38.15 0 0 37.532 99.967 91.265 55.432 38.15 0 0 106.011 12.785 91.265 55.432 38.15 0 0 4.121-6.762 91.265 55.432 38.15 0 1-103.24-15.623 91.265 55.432 38.15 0 1-41.57-93.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#5f1004",
      fillOpacity: 1
    },
    d: "M229.597 408.318a91.265 55.432 38.15 0 0-2.854 2.924 91.265 55.432 38.15 0 0 37.532 99.967 91.265 55.432 38.15 0 0 106.011 12.785 91.265 55.432 38.15 0 0 4.122-6.761 91.265 55.432 38.15 0 1-103.24-15.624 91.265 55.432 38.15 0 1-41.571-93.29z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "logo_svg__logo-needle",
    style: {
      display: "inline",
      fill: "#efefe2",
      stroke: "url(#logo_svg__b)",
      strokeWidth: 1.12999
    },
    d: "M239.933-17.691c-11.886 1.944 5.224 37.791 36.653 73.507 130.162 147.918 261.257 301.704 390.836 453l93.4 83.316-76.084-98.091C556.285 345.628 422.948 182.89 302.743 34.514c-24.946-30.793-50.925-54.15-62.81-52.205Zm57.232 56.748c26.49 32.528 44.58 59.599 40.448 62.982-4.135 3.384-28.947-18.223-55.449-50.766-26.498-32.539-44.619-61.65-38.412-63.068 6.207-1.418 29.34 21.293 53.413 50.852z"
  })));
};

export default SvgLogo;